import runtimeEnv from "@mars/heroku-js-runtime-env";
const env = runtimeEnv();

export default url => `${env.REACT_APP_API_HOST}${url}`;



// WEBPACK FOOTER //
// ./src/utils/buildEndpoint.js